import React from 'react';

export const IteroLogo = () => (
  <svg
    width="216"
    height="84"
    viewBox="0 0 72 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64.1479 19.7792C64.1507 18.7027 63.9397 17.6364 63.5272 16.6421C63.1147 15.6478 62.5088 14.7454 61.7448 13.987C60.1566 12.4036 57.9917 11.532 55.6453 11.532C53.3009 11.532 51.1342 12.4036 49.5479 13.987C48.7861 14.7461 48.1831 15.6491 47.7738 16.6435C47.3645 17.6379 47.1573 18.7039 47.1641 19.7792C47.1641 22.0073 47.9748 24.0664 49.4835 25.579C51.0396 27.1397 53.2291 28 55.6453 28C58.0617 28 60.2511 27.1397 61.809 25.579C63.3159 24.0664 64.1479 22.0073 64.1479 19.7792ZM60.3286 19.7792C60.3286 22.3042 58.141 24.5192 55.6453 24.5192C53.1515 24.5192 50.962 22.3042 50.962 19.7792C50.9573 19.1467 51.0785 18.5196 51.3188 17.9344C51.559 17.3493 51.9134 16.8179 52.3612 16.3712C53.2325 15.5008 54.4138 15.0118 55.6454 15.0118C56.877 15.0118 58.0582 15.5008 58.9295 16.3712C59.3777 16.8176 59.7323 17.349 59.9726 17.9342C60.2128 18.5194 60.3339 19.1466 60.3286 19.7792ZM41.0343 15.8294H45.6958V11.8713H37.0772V27.7249H41.0343V15.8294ZM21.5028 21.2945H33.9304V20.7378C33.9304 18.0643 33.1402 15.7681 31.6447 14.0977C30.1623 12.4433 28.0447 11.532 25.6832 11.532C23.3595 11.532 21.257 12.3989 19.7673 13.9738C18.3359 15.4855 17.5475 17.5369 17.5475 19.7517C17.5475 21.9185 18.3284 23.9415 19.7445 25.4476C21.3156 27.117 23.5145 28 26.1049 28C28.7234 28 30.8827 27.0196 32.8698 24.9239L30.3305 22.3798C29.1262 23.7799 27.6552 24.5192 26.0765 24.5192C24.8362 24.5192 23.732 24.1401 22.8831 23.4217C22.2239 22.8637 21.7438 22.1238 21.5028 21.2945ZM21.4859 18.0956C21.9037 16.5584 23.1723 15.0118 25.6549 15.0118C27.7308 15.0118 29.3701 16.2521 29.8371 18.0956H21.4859ZM14.3009 7.91404H19.7764V3.95686H4.8682V7.91404H10.3437V27.7249H14.3009V7.91404Z"
      fill="white"
      fillOpacity="0.93"
    />
    <path
      d="M41.0343 15.8294H45.6958V11.8713H37.0772V27.7249H41.0343V15.8294Z"
      fill="white"
      fillOpacity="0.93"
    />
    <path
      d="M4.86612 11.8713H0.908936V27.7249H4.86612V11.8713Z"
      fill="white"
      fillOpacity="0.93"
    />
    <path
      d="M4.86611 0H0.908936V3.95718H4.86611V0Z"
      fill="white"
      fillOpacity="0.93"
    />
    <path
      d="M65.3605 11.8664H67.7554V12.3382H66.8311V14.8167H66.2798V12.3382H65.3605V11.8664Z"
      fill="white"
      fillOpacity="0.93"
    />
    <path
      d="M68.1406 11.8664H68.8662L69.3503 13.2707C69.4655 13.6152 69.6081 14.2613 69.6081 14.2613H69.6204C69.6204 14.2613 69.763 13.6192 69.8741 13.2707L70.349 11.8664H71.0909V14.8167H70.5793V13.2778C70.5793 12.9568 70.615 12.3586 70.615 12.3586H70.6068C70.6068 12.3586 70.4846 12.9018 70.3888 13.1953L69.8303 14.8167H69.386L68.8234 13.1953C68.7276 12.9018 68.6053 12.3586 68.6053 12.3586H68.5972C68.5972 12.3586 68.6329 12.9568 68.6329 13.2778V14.8167H68.1406V11.8664Z"
      fill="white"
      fillOpacity="0.93"
    />
  </svg>
);
